(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Attivita', Attivita);

    Attivita.$inject = ['$resource'];

    function Attivita ($resource) {
        var resourceUrl =  'api/attivitas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
